module.exports = __webpack_public_path__ + "img/CM-SL-CA-Kia-Playful-1.5d341627.jpg";